import React, { useState } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { applyClasses, applyProps } from '../shared/js';

import styles from './nav.module.scss';

const NavLinks = ({ links, ...props }) => (
  <div
    className={cn(styles.navLinks, applyClasses(props, styles))}
    {...applyProps(props)}
  >
    {links.map((link, index) => (
      <NavLink
        key={index}
        url={link.url}
        label={link.label}
        dropdownLinks={link.dropdownLinks}
      />
    ))}
  </div>
);

const NavLink = ({ url, label, dropdownLinks }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={cn(styles.navLink)}>
      <div className={styles.navLinkToggle}>
        <a
          href={url}
          className={cn(styles.navLinkButton)}
          aria-label={`${label}, tab to the next button to expand the sub-menu`}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
        >
          {label}
        </a>
        {dropdownLinks.length > 0 && (
          <button
            className={cn(styles.accessibleToggle)}
            aria-label={`Toggle the ${label} sub-menu`}
            onClick={() => setOpen(!open)}
          >
            {open ? '-' : '+'}
          </button>
        )}
      </div>
      {dropdownLinks.length > 0 && (
        <div
          className={cn(styles.navLinkDropdown, {
            [styles.dropdownOpen]: open,
          })}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
        >
          {dropdownLinks.map((link, index) => (
            <NavLink
              key={index}
              url={link.url}
              label={link.label}
              dropdownLinks={link.dropdownLinks}
            />
          ))}
        </div>
      )}
    </div>
  );
};

NavLinks.propTypes = {
  /** The Nav Sub-components making up the nav */
  links: PropTypes.arrayOf(PropTypes.object),
  /** A style object forwarded to the main nav component */
  style: PropTypes.any,
  /** A class name forwarded to the main nav component */
  className: PropTypes.string,
};

NavLinks.defaultProps = {
  links: [],
  style: undefined,
  className: undefined,
};

NavLink.propTypes = {
  /** The URL of the page the button should link to */
  url: PropTypes.string,
  /** The text content of the link */
  label: PropTypes.any,
  /** The links that appear in the dropdown when the link is hovered over */
  dropdownLinks: PropTypes.arrayOf(PropTypes.object),
};

NavLink.defaultProps = {
  url: undefined,
  label: undefined,
  dropdownLinks: [],
};

export default NavLinks;
